'use client';

import { useQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { memo, useEffect } from 'react';
import { bannerQueryOptions, USER_BANNERS_STALE_TIME } from '@/queries/banners/banners.queries';
import { useAppSelector } from '@/redux/hooks';
import DefaultBanners from './components/DefaultBanners';

const LobbyBanners = memo(() => {
  const queryClient = useQueryClient();
  const userSession = useAppSelector(state => state.user.userSession);

  const { data: publicBanners } = useSuspenseQuery(bannerQueryOptions.allPublicBanners());

  const { data: userBanners } = useQuery({
    ...bannerQueryOptions.usersBanners({ staleTime: USER_BANNERS_STALE_TIME }),
    enabled: Boolean(userSession),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (userSession) {
      return;
    }

    queryClient.removeQueries({ queryKey: bannerQueryOptions.usersBanners().queryKey });
  }, [userSession, queryClient]);

  const banners = userSession ? userBanners ?? publicBanners : publicBanners;

  return (
    <DefaultBanners banners={banners ?? []} />
  );
});

export default LobbyBanners;
LobbyBanners.displayName = 'LobbyBanners';
